import Vue from 'vue'
import { reactive, watch, computed } from '@vue/composition-api'


const globalState = Vue.observable({
  index: 0,
})


export default function useLoader() {

  const isActive = computed(() => globalState.index > 0)

  function show() {
    globalState.index++
  }

  function hide() {
    globalState.index = Math.max(0, --globalState.index)
    //globalState.index--
  }

  function cancel() {
    globalState.index = 0
  }

  // todo: improve
  function bind(ref, inversed = false) {
    watch(ref, (newVal, oldVal) => {

      if (newVal != oldVal) {
        (inversed ? !newVal : newVal) ? show() : hide()
      }


    }, { immediate: true })
  }

  return {
    isActive,
    show,
    hide,
    cancel,
    bind,
  }

}
